
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_1d38c_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_1d38c_14",
  "token-trigger": "awsui_token-trigger_vm8qf_1d38c_18",
  "token-trigger-invalid": "awsui_token-trigger-invalid_vm8qf_1d38c_43",
  "token-trigger-warning": "awsui_token-trigger-warning_vm8qf_1d38c_55",
  "token-trigger-disabled": "awsui_token-trigger-disabled_vm8qf_1d38c_67",
  "token-trigger-readonly": "awsui_token-trigger-readonly_vm8qf_1d38c_77",
  "grouped": "awsui_grouped_vm8qf_1d38c_82",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_1d38c_88",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_1d38c_92",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_1d38c_98",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_1d38c_102",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_1d38c_106",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_1d38c_112",
  "token-list": "awsui_token-list_vm8qf_1d38c_117",
  "token-list-item": "awsui_token-list-item_vm8qf_1d38c_131",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_1d38c_135",
  "search-icon": "awsui_search-icon_vm8qf_1d38c_139",
  "pill-icon": "awsui_pill-icon_vm8qf_1d38c_145",
  "pill-icon-open": "awsui_pill-icon-open_vm8qf_1d38c_161",
  "token-trigger-container": "awsui_token-trigger-container_vm8qf_1d38c_165",
  "measurement-container": "awsui_measurement-container_vm8qf_1d38c_170",
  "overflow-panel": "awsui_overflow-panel_vm8qf_1d38c_183",
  "overflow-panel-list": "awsui_overflow-panel-list_vm8qf_1d38c_217",
  "overflow-panel-item": "awsui_overflow-panel-item_vm8qf_1d38c_227",
  "token-overflow-pill": "awsui_token-overflow-pill_vm8qf_1d38c_234"
};
  